module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BT - Bhutan.5f3df42f.svg";